module.exports = __webpack_public_path__ + "img/logo-tag-light.6a5aa6ed.png";